import { ADDRESS_VERIFICATION_FEATURE } from 'shared/form/addressVerificationConstants';
import { useFlag } from 'shared/settings/FeatureToggles';

export function useIsAddressVerificationEnabled(): boolean {
  return useFlag(ADDRESS_VERIFICATION_FEATURE);
}
